<template>
  <div class="pc-competition-detail detail-page">
    <BreadCrumb :data="breadcrumb" :title="'作品详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 基本介绍 -->

    <div class="detail-form-information" v-show="!isEditting">
      <h2>基本信息</h2>
      <div class="form-content">
        <div class="form-content-img">
          <img
            v-if="competitionWorkDetail.cover_image"
            :src="competitionWorkDetail.cover_image"
            alt=""
          />
          <img v-else src="../../../../static/image/no-img.png" alt="" />
        </div>
        <ul class="form-content-description">
          <li class="one-third">
            <h4>作品号码</h4>
            <span>{{ competitionWorkDetail.works_code }}</span>
          </li>
          <li class="exclusive">
            <h4>作品中文名</h4>
            <span>{{
              competitionWorkDetail.chinese_name
                ? competitionWorkDetail.chinese_name
                : "暂无"
            }}</span>
          </li>
          <li class="exclusive">
            <h4>作品英文名</h4>
            <span>{{
              competitionWorkDetail.english_name
                ? competitionWorkDetail.english_name
                : "暂无"
            }}</span>
          </li>
          <li class="exclusive">
            <h4>团队名称</h4>
            <span>{{
              competitionWorkDetail.team_name
                ? competitionWorkDetail.team_name
                : "暂无"
            }}</span>
          </li>
          <li class="half">
            <h4>建成情况</h4>
            <span v-if="competitionWorkDetail.built_case">{{
              competitionWorkDetail.built_case
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>建成成本</h4>
            <span v-if="competitionWorkDetail.built_cost">{{
              competitionWorkDetail.built_cost
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>公司</h4>
            <span v-if="competitionWorkDetail.company">{{
              competitionWorkDetail.company
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>曾获奖项</h4>
            <span v-if="competitionWorkDetail.works_award">{{
              competitionWorkDetail.works_award
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>作品类型</h4>
            <span v-if="competitionWorkDetail.works_type">{{
              competitionWorkDetail.works_type
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>经纬度</h4>
            <span
              >lng{{ competitionWorkDetail.lng }} lat{{
                competitionWorkDetail.lat
              }}</span
            >
          </li>
          <li class="half">
            <h4 class="choice">提交时间</h4>
            <span>{{ competitionWorkDetail.submit_time }} </span>
          </li>
          <li class="half">
            <h4>备注</h4>
            <span v-if="competitionWorkDetail.note">{{
              competitionWorkDetail.note
            }}</span>
            <span v-else>暂无</span>
          </li>
          <li class="half">
            <h4>预审核</h4>
            <!-- <el-switch
              v-model="competitionWorkDetail.pre_audit"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch> -->
            <span v-if="competitionWorkDetail.pre_audit == 0"> 未审核 </span>
            <span v-if="competitionWorkDetail.pre_audit == 1"> 已通过 </span>
            <span v-if="competitionWorkDetail.pre_audit == 2"> 未通过 </span>
          </li>
          <li class="half">
            <h4>提交状态</h4>
            <el-switch
              v-model="competitionWorkDetail.submit_status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="half">
            <h4>预审信息</h4>
            <p>{{ competitionWorkDetail.pre_audit_message }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="detail-form-information" v-show="isEditting">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="form-content-img">
          <UploadImage
            :img="competitionWorkDetail.cover_image"
            :width="268"
            :height="150"
            @getUploadImage="getUploadImageCover"
            class="form-content-img"
          ></UploadImage>
        </div>

        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>作品号码</h4>
            <span>{{ competitionWorkDetail.works_code }}</span>
          </li>
          <li class="exclusive">
            <h4>作品中文名<span>*</span></h4>
            <el-input
              v-model.number="competitionWorkDetail.chinese_name"
              placeholder="请输入中文名"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>作品英文名</h4>
            <el-input
              v-model.number="competitionWorkDetail.english_name"
              placeholder="请输入英文名"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4 class="choice">提交时间<span>*</span></h4>
            <el-date-picker
              v-model="competitionWorkDetail.submit_time"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择提交时间"
            >
            </el-date-picker>
          </li>
          <li class="exclusive">
            <h4>团队名称</h4>
            <el-input
              v-model.number="competitionWorkDetail.team_name"
              placeholder="请输入团队名称"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>建成情况</h4>
            <el-input
              v-model="competitionWorkDetail.built_case"
              placeholder="请输入建成情况"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>建成成本</h4>
            <el-input
              v-model="competitionWorkDetail.built_cost"
              placeholder="请输入建成成本"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>院校/公司</h4>
            <el-input
              v-model="competitionWorkDetail.company"
              placeholder="请输入公司名称"
            ></el-input>
          </li>
          <li class="half">
            <h4>曾获奖项</h4>
            <el-input
              v-model="competitionWorkDetail.works_award"
              placeholder="请输入曾获奖项"
            ></el-input>
          </li>
          <li class="half">
            <h4>作品类型</h4>
            <el-input
              v-model="competitionWorkDetail.works_type"
              placeholder="请输入作品类型"
            ></el-input>
          </li>
          <li class="one-third">
            <h4>经度</h4>
            <el-input-number
              v-model.number="competitionWorkDetail.lat"
              @input.native="onInput"
            ></el-input-number>
          </li>
          <li class="one-third">
            <h4>纬度</h4>
            <el-input-number
              v-model.number="competitionWorkDetail.lng"
              @input.native="onInput"
            ></el-input-number>
          </li>

          <li class="half">
            <h4>备注</h4>
            <el-input
              v-model="competitionWorkDetail.note"
              placeholder="请输入备注"
            ></el-input>
          </li>
          <li class="half">
            <h4>预审核</h4>
            <!-- <el-switch
              v-model="competitionWorkDetail.pre_audit"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch> -->
            <el-select
              style="min-width: 60%"
              :change="selectPreAudit(competitionWorkDetail)"
              v-model="competitionWorkDetail.pre_audit"
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="(item, index) in preAuditList"
                :key="index"
                :label="item.chinese_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4>提交状态</h4>
            <el-switch
              disabled
              v-model="competitionWorkDetail.submit_status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="half">
            <h4>预审信息</h4>
            <el-input
              :disabled="competitionWorkDetail.pre_audit == 1"
              v-model="competitionWorkDetail.pre_audit_message"
              placeholder="请输入预审信息"
            ></el-input>
          </li>
        </ul>
      </div>
    </div>
    <NewCompetitionWorkDetailTable
      :competitionWorkDetail="competitionWorkDetail"
    />
    <!-- 课程简介 -->
    <div class="pc-dataDetail-intro">
      <h2>作品介绍</h2>
      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="5"
          placeholder="请输入内容"
          v-model="competitionWorkDetail.chinese_introduce"
        >
        </el-input>
        <p v-else>
          {{
            competitionWorkDetail.chinese_introduce
              ? competitionWorkDetail.chinese_introduce
              : "暂无"
          }}
        </p>
      </div>
      <TranslateText
        class="translate-btn"
        v-if="isEditting"
        :chinese="competitionWorkDetail.chinese_introduce"
        :english="competitionWorkDetail.english_introduce"
        @returnTranslate="returnTranslate"
      />
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          type="textarea"
          :rows="5"
          v-if="isEditting"
          placeholder="请输入内容"
          v-model="competitionWorkDetail.english_introduce"
        >
        </el-input>
        <p v-else>
          {{
            competitionWorkDetail.english_introduce
              ? competitionWorkDetail.english_introduce
              : "暂无"
          }}
        </p>
      </div>
    </div>

    <div class="works-images">
      <h2>作品图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadWorksImage"
          class="form-content-img upload-image"
        ></UploadImage>

        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in competitionWorkDetail.works_image_list"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae1(index)"
              class="el-icon-error iconPosi"
            ></i>
            <p>
              <a class="el-icon-document" :href="item">{{
                item ? "下载链接" : "暂无"
              }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="works-images">
      <h2>专利</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadWorksPatentImage"
          class="form-content-img upload-image"
        ></UploadImage>

        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in competitionWorkDetail.patent_list"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae2(index)"
              class="el-icon-error iconPosi"
            ></i>
            <p>
              <a class="el-icon-document" :href="item">{{
                item ? "下载链接" : "暂无"
              }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="pc-works-books" v-show="!isEditting"></div>
    <div class="pc-works-books" v-show="!isEditting"></div>

    <div class="pc-works-books" v-show="!isEditting">
      <div class="pc-works-textbook">
        <h2>作品文件</h2>
        <a class="el-icon-document" :href="competitionWorkDetail.zip">{{
          competitionWorkDetail.zip ? competitionWorkDetail.zip : "暂无"
        }}</a>
      </div>
      <div class="pc-works-audio">
        <h2>作品音频文件</h2>
        <a class="el-icon-document" :href="competitionWorkDetail.audio">{{
          competitionWorkDetail.audio ? competitionWorkDetail.audio : "暂无"
        }}</a>
      </div>
    </div>
    <div class="pc-works-books">
      <div class="pc-works-textbook1">
        <h2>作品评分</h2>
        <div class="pc-works-textbook2">
          <p>
            第一轮评分:
            {{
              competitionWorkDetail.round1_score == null
                ? "暂无评分"
                : competitionWorkDetail.round1_score
            }}
          </p>
          <p>
            第二轮评分:
            {{
              competitionWorkDetail.round2_score == null
                ? "暂无评分"
                : competitionWorkDetail.round2_score
            }}
          </p>
          <p>
            第三轮评分:
            {{
              competitionWorkDetail.round3_score == null
                ? "暂无评分"
                : competitionWorkDetail.round3_score
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="pc-works-books" v-if="awardList ? awardList.length > 1 : ''">
      <div class="pc-works-textbook1">
        <h2>作品奖项一</h2>
        <div class="pc-works-textbook2">
          <div>
            <UploadImage
              :img="competitionWorkDetail.award1_link"
              :width="268"
              :height="150"
              @getUploadImage="getUploadAward1Link"
              class="form-content-img"
            ></UploadImage>
          </div>
          <div>
            <el-select
              :disabled="!isEditting"
              v-model="competitionWorkDetail.award1"
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="(item, index) in awardList"
                :key="index"
                :label="item.chinese_award_name"
                :value="
                  item.chinese_award_name == '无'
                    ? null
                    : item.chinese_award_name
                "
              ></el-option>
            </el-select>
            <span>
              <a
                class="el-icon-document"
                :href="competitionWorkDetail.award1_link"
                >{{
                  competitionWorkDetail.award1_link ? "下载链接" : "暂无"
                }}</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="pc-works-books" v-if="awardList ? awardList.length > 2 : ''">
      <div class="pc-works-textbook1">
        <h2>作品奖项二</h2>
        <div class="pc-works-textbook2">
          <div>
            <UploadImage
              :img="competitionWorkDetail.award2_link"
              :width="268"
              :height="150"
              @getUploadImage="getUploadAward2Link"
              class="form-content-img"
            ></UploadImage>
          </div>
          <div>
            <el-select
              :disabled="!isEditting"
              v-model="competitionWorkDetail.award2"
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="(item, index) in awardList"
                :key="index"
                :label="item.chinese_award_name"
                :value="
                  item.chinese_award_name == '无'
                    ? null
                    : item.chinese_award_name
                "
              ></el-option>
            </el-select>
            <span>
              <a
                class="el-icon-document"
                :href="competitionWorkDetail.award2_link"
                >{{
                  competitionWorkDetail.award2_link ? "下载链接" : "暂无"
                }}</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="pc-works-books" v-if="awardList ? awardList.length > 3 : ''">
      <div class="pc-works-textbook1">
        <h2>作品奖项三</h2>
        <div class="pc-works-textbook2">
          <div>
            <UploadImage
              :img="competitionWorkDetail.award3_link"
              :width="268"
              :height="150"
              @getUploadImage="getUploadAward3Link"
              class="form-content-img"
            ></UploadImage>
          </div>
          <div>
            <el-select
              :disabled="!isEditting"
              v-model="competitionWorkDetail.award3"
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="(item, index) in awardList"
                :key="index"
                :label="item.chinese_award_name"
                :value="
                  item.chinese_award_name == '无'
                    ? null
                    : item.chinese_award_name
                "
              ></el-option>
            </el-select>
            <span>
              <a
                class="el-icon-document"
                :href="competitionWorkDetail.award3_link"
                >{{
                  competitionWorkDetail.award3_link ? "下载链接" : "暂无"
                }}</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="works-doc">
      <h2>作品文档</h2>

      <div class="doc-box">
        <UploadFile1
          v-if="isEditting"
          :file="competitionWorkDetail.doc"
          @getUploadFile="getUploadDoc"
          :title="'作品文档'"
        ></UploadFile1>

        <div class="doc-list">
          <div
            class="doc-item"
            v-for="(item, index) in competitionWorkDetail.doc_list"
            :key="index"
          >
            <p>{{ item }}</p>
            <!-- <pdf ref="pdf" src="item"> </pdf> -->
            <i
              v-show="isEditting"
              @click="removeImgae3(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <div class="works-model">
      <h2>作品模型文件</h2>

      <div class="model-box">
        <UploadFile1
          v-if="isEditting"
          :file="competitionWorkDetail.model"
          @getUploadFile="getUploadModel"
          :title="'作品模型'"
        ></UploadFile1>

        <div class="model-list">
          <div
            class="model-item"
            v-for="(item, index) in competitionWorkDetail.model_list"
            :key="index"
          >
            <p>{{ item }}</p>
            <i
              v-show="isEditting"
              @click="removeImgae4(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <div class="pc-works-books" v-show="isEditting">
      <!-- 作品文件 -->
      <div class="pc-works-textbook">
        <h2>作品文件</h2>
        <UploadFile
          :file="competitionWorkDetail.zip"
          @getUploadFile="getUploadZip"
          :title="'作品文件'"
        ></UploadFile>
      </div>
      <!-- 作品音频文件 -->
      <div class="pc-works-handouts">
        <h2>作品音频文件</h2>
        <UploadFile
          :file="competitionWorkDetail.audio"
          @getUploadFile="getUploadAudio"
          :title="'作品音频'"
        ></UploadFile>
      </div>
    </div>

    <div class="pc-works-books" v-if="$route.query.method == 'update'">
      <div class="pc-works-video">
        <h2>作品视频文件</h2>
        <video controls :src="competitionWorkDetail.video"></video>
        <UploadVideo
          :isEditting="isEditting"
          :file="competitionWorkDetail.video"
          @getUploadVideo="getUploadVideo"
          :title="'作品视频'"
        ></UploadVideo>
      </div>
    </div>

    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import pdf from "vue-pdf";
import UploadImage from "../../componentSet/uploadImage.vue";
import UploadFile from "../../componentSet/uploadFile.vue";
import UploadFile1 from "./components/uploadFile1.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import NewCompetitionWorkDetailTable from "./components/NewCompetitionWorkDetailTable.vue";
import {
  competitionWorkDetail_Api,
  updateCompetitionWorkDetail_Api,
  createCompetitionWorkDetail_Api,
  competitionAward_Api,
} from "../../../apis/competition.api";
import TranslateText from "../../componentSet/TranslateText.vue";
import UploadVideo from "./components/UploadVideo.vue";
export default {
  name: "Pdf",
  components: {
    SaveGroup,
    UploadFile,
    BreadCrumb,
    UploadImage,
    TranslateText,
    UploadVideo,
    UploadFile1,
    NewCompetitionWorkDetailTable,
    pdf,
  },
  data() {
    return {
      competitionWorkDetail: {
        competition_id: null,
        // works_id: null,
        patent_list: [],
        works_image_list: [],
        doc_list: [],
        model_list: [],
      },
      awardList: [],
      preAuditList: [
        { chinese_name: "未审核", id: 0 },
        { chinese_name: "已通过", id: 1 },
        { chinese_name: "未通过", id: 2 },
      ],
      isEditting: false,
      deleteDialogVisible: false,
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        {
          name: "作品列表",
          link: `/admin/newCompetitionWork?id=${this.$route.query.competition_id}`,
        },
        {
          name: `${
            this.competitionWorkDetail.chinese_name
              ? this.competitionWorkDetail.chinese_name
              : ""
          }`,
          link: "/admin/newCompetitionWorkDetail",
        },
      ];
    },
  },
  mounted() {
    this.competitionWorkDetail.competition_id =
      +this.$route.query.competition_id;
    this.competitionWorkDetail.submit_status = 1;
    if (this.$route.query.method == "update") {
      this.competitionWorkDetail.works_id = this.$route.query.id;
      this.getCompetitionWorkDetail();
    } else {
      this.isEditting = true;
    }
    if (this.$route.query.method == "add") {
      return;
    } else {
      competitionAward_Api(this.$route.query.competition_id).then((res) => {
        console.log(res);
        this.awardList = res.data;
        this.awardList.push({
          chinese_award_name: "无",
          english_award_name: "wu",
        });
      });
    }
  },
  methods: {
    selectPreAudit(item) {
      console.log(item);
      if (item.pre_audit == 1) {
        this.competitionWorkDetail.pre_audit_message = "提交成功";
      }
    },
    onInput(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
    },
    getUploadDoc(file_url) {
      this.competitionWorkDetail.doc_list.unshift(file_url);
      console.log(this.competitionWorkDetail.doc_list);
      this.$forceUpdate();
    },
    getUploadZip(file_url) {
      this.competitionWorkDetail.zip = file_url;
    },
    getUploadModel(file_url) {
      this.competitionWorkDetail.model_list.unshift(file_url);
      console.log(this.competitionWorkDetail.model_list);
      this.$forceUpdate();
    },

    getUploadVideo(file_url) {
      this.competitionWorkDetail.video = file_url;
    },
    getUploadAudio(file_url) {
      this.competitionWorkDetail.audio = file_url;
    },
    removeImgae1(index) {
      this.competitionWorkDetail.works_image_list.splice(index, 1);
      this.$forceUpdate();
    },
    removeImgae2(index) {
      this.competitionWorkDetail.patent_list.splice(index, 1);
      console.log(this.competitionWorkDetail.patent_list);
      this.$forceUpdate();
    },
    removeImgae3(index) {
      this.competitionWorkDetail.doc_list.splice(index, 1);
      this.$forceUpdate();
    },
    removeImgae4(index) {
      this.competitionWorkDetail.model_list.splice(index, 1);
      this.$forceUpdate();
    },
    getUploadWorksImage(img_url) {
      console.log(this.competitionWorkDetail.works_image_list);
      this.competitionWorkDetail.works_image_list.unshift(img_url);
      console.log(this.competitionWorkDetail.works_image_list);
      this.$forceUpdate();
    },
    getUploadWorksPatentImage(img_url) {
      this.competitionWorkDetail.patent_list.unshift(img_url);
      console.log(this.competitionWorkDetail.patent_list);
      this.$forceUpdate();
    },
    returnTranslate(data, flag) {
      flag == 1
        ? (this.competitionWorkDetail.english_introduce = data)
        : (this.competitionWorkDetail.chinese_introduce = data);
      console.log(data);
      console.log(flag);
    },
    cancelUpdate() {
      this.getCompetitionWorkDetail("取消成功");
      this.isEditting = false;
    },
    add() {
      let formattedData = this.validateForm(this.competitionWorkDetail);
      if (!formattedData) {
        return;
      } else {
        formattedData.competition_id = +this.$route.query.competition_id;
        console.log(this.$route.query.id);
        createCompetitionWorkDetail_Api(formattedData)
          .then((res) => {
            this.isEditting = false;
            this.competitionWorkDetail.id = res.data.id;
            this.competitionWorkDetail.submit_status = 1;

            // this.competitionWorkDetail.competition_id = + this.$route.query.competition_id;
            this.$router.push({
              path: `/admin/newCompetitionWorkDetail?competition_id=${formattedData.competition_id}`,
              query: { id: res.data.id, method: "update" },
            });
            this.getCompetitionWorkDetail();
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      console.log(this.competitionWorkDetail);
      if (this.competitionWorkDetail.pre_audit == 1) {
        this.competitionWorkDetail.pre_audit_message = "提交成功";
      }
      this.competitionWorkDetail.works_id = +this.$route.query.id;
      let formattedData = this.validateForm(this.competitionWorkDetail);
      console.log(this.competitionWorkDetail, formattedData);
      if (!formattedData) {
        return;
      } else {
        updateCompetitionWorkDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getCompetitionWorkDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    recover() {
      this.getCompetitionWorkDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/competition/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    // add() {
    // },
    validateForm(formData) {
      //表单校验
      console.log(formData);
      if (!formData.chinese_name) {
        this.$global.error(this, "请输入中文名称");
        return false;
      }
      if (!formData.submit_time) {
        this.$global.error(this, "请输入提交时间");
        return false;
      }
      // formData.works_image = formData.works_image_list;
      // formData.patent = formData.patent_list;
      // formData.doc = formData.doc_list;
      // formData.model = formData.model_list;
      formData.id = formData.works_id;
      formData.competition_id = formData.competition_id;
      return formData;
    },
    getUploadHandoutFile(file_url) {
      this.competitionWorkDetail.handout_file = file_url;
    },
    getUploadRecommendBook(file_url) {
      this.competitionWorkDetail.recommend_book = file_url;
    },
    getCompetitionWorkDetail(hint) {
      competitionWorkDetail_Api(this.$route.query.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.competitionWorkDetail = res.data.works_data;
        if (this.competitionWorkDetail.patent) {
          this.competitionWorkDetail.patent_list =
            this.competitionWorkDetail.patent;
        } else {
          this.competitionWorkDetail.patent_list = [];
        }
        if (this.competitionWorkDetail.works_image) {
          this.competitionWorkDetail.works_image_list =
            this.competitionWorkDetail.works_image;
        } else {
          this.competitionWorkDetail.works_image_list = [];
        }
        if (this.competitionWorkDetail.doc) {
          this.competitionWorkDetail.doc_list = this.competitionWorkDetail.doc;
        } else {
          this.competitionWorkDetail.doc_list = [];
        }
        if (this.competitionWorkDetail.model) {
          this.competitionWorkDetail.model_list =
            this.competitionWorkDetail.model;
        } else {
          this.competitionWorkDetail.model_list = [];
        }

        console.log(this.competitionWorkDetail);
      });
    },

    getUploadImageCover(data) {
      this.competitionWorkDetail.cover_image = data;
    },
    getUploadAward1Link(data) {
      this.competitionWorkDetail.award1_link = data;
    },
    getUploadAward2Link(data) {
      this.competitionWorkDetail.award2_link = data;
    },
    getUploadAward3Link(data) {
      this.competitionWorkDetail.award3_link = data;
    },

    edit() {
      this.isEditting = true;
    },
  },
};
</script>


<style lang="scss" scoped>
.pc-competition-detail {
  /deep/ .el-select {
    width: 100%;
  }

  .pc-competition-textbook,
  .pc-competition-handouts {
    @include box-model;
    padding-bottom: 50px;
    a {
      word-break: break-all;
      font-size: 14px;
    }
    a:hover {
      color: $lightenYellow;
    }
    a:before {
      color: $mainTitle;
      text-decoration: none;
    }
  }
  .pc-competition-books {
    display: flex;
    width: 100%;
    justify-content: space-between;
    /deep/ button.el-button.el-button--primary.el-button--small {
      padding: 0;
      background: #fff;
      color: #000;
      border: none;
    }
    /deep/ .el-icon-document:before {
      margin-right: 10px;
    }
    .pc-competition-textbook {
      width: 48%;
      margin-right: 40px;
    }
    .pc-competition-handouts {
      width: 48%;
    }
  }
}

.form-content-img {
  width: 250px;
  height: 140px;
}
.works-images {
  @include box-model;
  .images-box {
    overflow-x: auto;
    display: flex;
    min-height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      flex-direction: column;
      .image-item {
        position: relative;
        display: inline-block;
        border: 1px dashed #ccc;
        margin: 0 20px 60px 0;
        height: 300px;
        width: 300px;
        img {
          object-fit: contain;
          height: 300px;
          width: 300px;
        }
        .el-icon-error {
          color: black;
          cursor: pointer;
          position: absolute;
          top: 20px;
          right: 0;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.works-doc {
  @include box-model;
  .doc-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    min-height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .doc-list {
      display: flex;
      flex-direction: column;
      .doc-item {
        position: relative;
        display: inline-block;
        margin-bottom: 20px;
        margin-left: 20px;
        p {
          height: 40px;
          width: 800px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
        }
        .el-icon-error {
          color: black;
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 0;
        }
      }
      .doc-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.works-model {
  @include box-model;
  .model-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    min-height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .model-list {
      display: flex;
      flex-direction: column;
      .model-item {
        position: relative;
        display: inline-block;
        margin-bottom: 20px;
        margin-left: 20px;
        p {
          height: 40px;
          width: 800px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
        }
        .el-icon-error {
          color: black;
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 0;
        }
      }
      .model-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.pc-works-books {
  display: flex;
  width: 100%;
  justify-content: space-between;
  /deep/ button.el-button.el-button--primary.el-button--small {
    padding: 0;
    background: #fff;
    color: #000;
    border: none;
  }
  /deep/ .el-icon-document {
    display: flex;
    margin-top: 20px;
  }
  /deep/ .el-icon-document:before {
    margin-right: 10px;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    overflow: hidden;
  }
  .pc-works-textbook {
    @include box-model;
    width: 48%;
    margin-right: 40px;
  }
  .pc-works-textbook1 {
    @include box-model;
    width: 100%;
    .pc-works-textbook2 {
      display: flex;
      div {
        margin-right: 30px;
      }
      p {
        width: 33%;
      }
    }
  }
  .pc-works-handouts {
    @include box-model;
    width: 48%;
  }
  .pc-works-video {
    @include box-model;
    width: 48%;
    video {
      width: 60%;
    }
  }
  .pc-works-audio {
    @include box-model;
    width: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/competition/NewCompetitionWorkDetail.vue